import React from 'react'

import theme from '../../constants/aampeTheme'

export default function BaseAlert({ Icon, title, color, bgColor, children }) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '2px',
                marginBottom: theme.spacing4(4),
                backgroundColor: bgColor,
                color: color,
                width: '100%',
                padding: theme.spacing4(1, 0),
            }}
        >
            <Icon
                style={{ fontSize: '22px', marginRight: theme.spacing4(2) }}
            />
            {title}
            {children && (
                <div style={{ marginLeft: theme.spacing4(4) }}>{children}</div>
            )}
        </div>
    )
}
